import { HandoutOverViewContainer } from 'modules/ReviewEducationalContent'

type Props = {}

const HandoutOverView = (props: Props) => {
    return (
        <HandoutOverViewContainer />
    )
}

export default HandoutOverView